import { computed, inject, Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../../base-workflow-state.service';
import { VideoFlowStateService } from '../video-flow-state.service';
import { VideoProductResponseService } from '../../../order-api-response/video-pd-response.service';
import { SatelliteHardwareSelectionData } from '../../../../../../../models/order/workflow/video/video-package-selection.model';
import { FlattenCustomization } from '../../../../../../../models/order/api-models/order-pd-response.model';

export const SatelliteHardwareSelectionSubgroupName = 'ATVEquipmentPay';

@Injectable({ providedIn: 'root' })
export class SatelliteHardwareSelectionStateService extends BaseWorkflowStateService<SatelliteHardwareSelectionData> {
    private flowStateService = inject(VideoFlowStateService);
    private videoPdResponseService = inject(VideoProductResponseService);
    override stateKey: string = 'satelliteHardwareSelection';

    customizationTypeQuery(cust: FlattenCustomization, customizationCode: string) {
        return cust.customization.SubGroupName === customizationCode;
    }

    private flowVisibleFilter(cust: FlattenCustomization) {
        return cust.customization.FlowVisible !== 'False' &&
            cust.customization.Choices?.Choice &&
            cust.customization.Choices.Choice.some((choice: any) => choice.FlowVisible !== 'False');
    }

    customizations = computed(() => this.videoPdResponseService.getCustomizations().filter(cust =>
        this.customizationTypeQuery(cust, SatelliteHardwareSelectionSubgroupName)
    ) || []);

    GetCommercialSatelliteEquipmentCustomization(): FlattenCustomization | undefined {
        const cust = this.videoPdResponseService.getCustomizations().find(cust => cust.customization.CustomizationCode.toLocaleLowerCase() === 'streamingdevice' && cust.customization.SubGroupName.toLocaleLowerCase() === 'atvequipment');
        return cust;
    }


    visibleCustomizations = computed(() => this.customizations().filter(this.flowVisibleFilter));

    protected override saveLocalDraft(): void {
        this.flowStateService.updateData({ [this.stateKey]: this.state() });
    }

    resetData() {
        this.state.set(null);
        this.saveLocalDraft();
    }
}
